import "../css"

addEventListener("change", ({ target }) => {
  if (target.matches("#folder")) {
    const folder = target.value
    const url = new URL(location)

    if (folder == "") {
      url.searchParams.delete("folder")
    } else {
      url.searchParams.set("folder", folder)
    }

    location.href = url
  }
})
